export const EMOJIS: any = {
  thumbsup: "👍",
  heart: "❤️",
  tada: "🎉",
  joy: "🤣",
  open_mouth: "😮",
  cry: "😢",
  pray: "🙏",
};
